/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import { translate } from '../../../../api/utils/i18nHelper';
import { CartInfoMessage } from './CartInfoMessage';

function CartInfo({ i18n, cartData, listModel }) {
    return (
        <div className="cart__content--info">
            <div className="checkout-card__group">
                <div className="checkout-card__group--item p-margin-none">
                    {listModel.subtotalMessage && <p dangerouslySetInnerHTML={{ __html: listModel.subtotalMessage }} />}
                </div>

                {listModel.cartAlerts &&
                    listModel.cartAlerts.map((alerts, i) => {
                        return <CartInfoMessage key={i} cartAlerts={alerts} />;
                    })}

                {(cartData.palletisation || cartData.grossWeight || cartData.netWeight) && (
                    <div className="checkout-card__group--item">
                        <div className="shipping-info">
                            <p className="cart__content--info-title">{translate(i18n, 'Shipping information')}</p>

                            <table className="table cart__content--info-table">
                                <tbody>
                                    {cartData.palletisation ? (
                                        <tr>
                                            <th>{translate(i18n, 'Palletisation')}</th>
                                            <td>{cartData.palletisation}</td>
                                        </tr>
                                    ) : null}
                                    {cartData.grossWeight ? (
                                        <tr>
                                            <th>{translate(i18n, 'Gross weight')}</th>
                                            <td>
                                                {cartData.grossWeight} {translate(i18n, cartData.weightUnit)}
                                            </td>
                                        </tr>
                                    ) : null}
                                    {cartData.netWeight ? (
                                        <tr>
                                            <th>{translate(i18n, 'Net weight')}</th>
                                            <td>
                                                {cartData.netWeight} {translate(i18n, cartData.weightUnit)}
                                            </td>
                                        </tr>
                                    ) : null}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

CartInfo.propTypes = {};
CartInfo.defaultProps = {};

export default CartInfo;
